<template>
  <NuxtLayout>
    <div class="webcatalog-page-content">
      <NuxtPage />
      <service-policy />
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import ServicePolicy from "~/components/organisms/ServicePolicy.vue";
import { setStateFromQueryString } from "~/composables/routeQuery";
import { registerTanQueryClient } from "~/composables/useTanQueryClient";

registerTanQueryClient();

const requestURL = useRequestURL();/* Client, Server どちらでも利用可能 */
const route = useRoute();
const initialRouteState = useInitialRouteState();
initialRouteState.setInitialRouteFullpath(requestURL, route); // ログイン処理後の戻り先

// URLのパース結果を State に保存 (config構築を待たなくてよい)
setStateFromQueryString();

// アプリケーション内config の構築 CSR における appEnv の決定が含まれる
const circlemsConfig = useCirclemsConfig();
circlemsConfig.initialize(requestURL);

// provide/inject は DependencyInjection の仕組みだった

if (import.meta.client) {
  useRouter().push(route.fullPath); // yarn generate するスタティックページに必要
}

// 以下はうまくいかなかったため checkPermission に組み込んだ
// ログインを一度試みてから指定されたページにアクセスする
// DOM 描画を待たなくてよいので onMounted よりも早いタイミング
// onBeforeMount(async () => {
//   if (!isLoginAttempted()) {
//     await getUserInfo()
//     await navigateTo(routeFullPath)
//   }
// })
</script>

<style lang="scss" scoped></style>
